import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row justify-center full-height"
};
const _hoisted_2 = { class: "full-page-width text-center self-center" };
const _hoisted_3 = ["src", "onload"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_chat_input = _resolveComponent("chat-input");
    const _component_general_dialog = _resolveComponent("general-dialog");
    return (_openBlock(), _createBlock(_component_general_dialog, {
        "full-screen": "",
        "lean-header": "",
        "white-close-btn": "",
        "close-btn-class": {
            'text-white': true
        },
        "custom-color": {
            'bg-black q-my-xs': true
        },
        "custom-card-class": {
            'bg-black': true
        },
        "custom-sticky-color": "bg-black",
        "model-value": _ctx.confirmShow,
        "onUpdate:modelValue": _ctx.clearData
    }, {
        "content-sections": _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "img-dialog-ht" }, {
                default: _withCtx(() => [
                    (_ctx.filePreview)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                (_ctx.uploadType === 'image')
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        alt: "Preview Pic",
                                        ref: "previewPicRef",
                                        class: "confirm-pic",
                                        src: _ctx.filePreview,
                                        onload: _ctx.getDimensions,
                                        onLoad: _cache[0] || (_cache[0] =
                                            //@ts-ignore
                                            (...args) => (_ctx.getDimensions && _ctx.getDimensions(...args)))
                                    }, null, 40, _hoisted_3))
                                    : (_openBlock(), _createBlock(_component_q_icon, {
                                        key: 1,
                                        name: "insert_drive_file",
                                        size: "3rem",
                                        color: "white"
                                    }))
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            })
        ]),
        "additional-section": _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                    _createVNode(_component_chat_input, {
                        onSendMessage: _ctx.uploadPics,
                        ref: "chatInputConfirm",
                        "btn-color": 'white',
                        "hide-attach": "",
                        dark: ""
                    }, null, 8, ["onSendMessage"])
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["model-value", "onUpdate:modelValue"]));
}
